const BaseErrorHandler = require('./baseErrors.handler')

class NetWorkErrorHandler extends BaseErrorHandler {
  check(resolve) {
    this.addError('code', 'NETWORK_ERROR')
    resolve()
  }

  constructor(err, form) {
    super(err, form)
    this.handler = [new Promise((resolve) => this.check(resolve))]
  }
}

module.exports = NetWorkErrorHandler
